import footerImage from 'src/assets/footerImage.png';

import axios from 'axios'
import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { APP_CONSTANTS } from 'src/consumer/constants'
import logo from 'src/assets/logo_brand.png'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import { apiURL } from 'src/consumer/services'
import forgotPasswordImage from 'src/assets/forgotPass_Image.png'

const Thankyou = (props) => {
  const pageId = 'forgotPasswordPage'

  const { localizedDataLoading, localizedData, localizedDataError } =
    useContext(LocalizationContext)
  const localizedStrings = localizedData?.[pageId]

  const handleSubmit = async (e) => {
    e.preventDefault()
    axios
      .get(`${apiURL}/api/user/forgot/password`, { params: { username: props.email } })
      .then((res) => {
        console.log(res.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  return (
    <>
      <div
        className="w-100 vh-100 d-flex flex-column justify-content-between"
        style={{ background: '#E5E5E5' }}
      >
        <div className="mx-auto d-flex flex-column gap-4 p-4 w-full align-items-center text-center">
          <img
            className="img-fluid rounded"
            src={APP_CONSTANTS.APP_LOGO_LINK}
            alt="Logo"
            onError={(e) => {
              e.target.src = logo
            }}
            style={{
              boxShadow: '10px 10px 10px rgb(0 0 0 / 50%)',
              borderRadius: '6px',
              width: '110px',
            }}
          />
          <div className="w-100 mt-6">
            <img className="h-20 mx-auto" src={forgotPasswordImage} style={{ width: '180px' }} />
            <h4 className=" display-10 fw-bold text-black">
              {localizedStrings?.we_have_sent_you_an_email || 'We have sent you an email'}
            </h4>
            <h5 className="w-50 mx-auto">
              {localizedStrings?.password_reset_link_text ||
                'We have sent a password reset link on your email. Kindly check your inbox and also spam section of your mail. If you did not recieve the mail, Kindly click here.'}
              <br />
              <button
                className="btn btn-primary m-4 rounded-4 mt-4 w-10 p-2 px-4  "
                onClick={handleSubmit}
              >
                {localizedStrings?.resend_password_reset_link || 'Re-send password change link.'}
              </button>
            </h5>
            <Link to={'/login'}>
              <button
                type="submit"
                className="btn btn-primary text-white p-2 px-4 rounded-4 w-5 mt-4 text-lg align-item-center"
              >
                {localizedStrings?.go_back_to_login_page || 'Go back to login page'}
              </button>
            </Link>
          </div>
        </div>
        <div className="w-100">
          <img className="w-100 h-32" src={footerImage}></img>
        </div>
      </div>
    </>
  )
}

export default Thankyou
